import React from "react";
import Header from "../header2/Header";
import Seo from "../seo/Seo";
import { motion } from "framer-motion";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { NavLink } from "react-router-dom";

const Performax = () => {
  return (
    <>
      <Seo
        title="Performax"
        description="Beginner friendly page for learning React Helmet."
        name="Company name."
        type="article"
        YahooSeeker="INDEX, FOLLOW"
        msnbot="INDEX, FOLLOW"
        googlebot="INDEX, FOLLOW"
        keywords="react, meta tags, seo"
        searchengines="ALL"
        canonical="https://www.grank.co.in/performax"
      ></Seo>

      <section className="section-top">
        <Header />
        {/* banner start */}
        <div
          className="creative-banner-display-ads"
          style={{ backgroundColor: "#fff", position: "relative" }}
        >
          <img
            className="img-fluid w-100 mobile-none"
            src="assest/photos/case-studies/performax-banner.png"
            alt="G-Rank"
          />
          <img
            className="img-fluid w-100 desktop-none"
            src="assest/photos/case-studies/performax-banner-mobile.png"
            alt="G-Rank"
          />

          <div className="case-sub-banner-div">
            <h2>Lifestyle Industry</h2>
          </div>
          <div className="case-sub-banner-div2">
            <h2>Active wear</h2>
          </div>
          <Breadcrumbs
            className="case-sub-banner-div"
            aria-label="breadcrumb"
            style={{ paddingTop: "40px", color: "#000" }}
          >
            <NavLink
              style={({ isActive }) => ({
                color: isActive ? "#000" : "#000",
              })}
              to="/"
            >
              <p>Home</p>
            </NavLink>

            <Typography color="#000">Performance</Typography>
          </Breadcrumbs>
        </div>
        {/* banner end */}
        {/* section2 Start */}
        <section className="web-section2">
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 align-self-center">
                <img
                  className="img-fluid w-100"
                  src="assest/photos/case-studies/sub-banner1.png"
                  alt="G-Rank"
                />
              </div>
              <div className="col-12 col-md-6 col-lg-6">
                <div className="row">
                  <div className="col-12">
                    <motion.h1
                      className="section2-web-develop-header"
                      initial={{ opacity: 0, scale: 0 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 1 }}
                    >
                      About the Client
                    </motion.h1>
                    <p className="section2-web-develop-passage">
                      Performax is a popular active-wear brand under Reliance
                      Retail specializing in sports apparel, footwear, and
                      accessories.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* section2 end */}
        <section className="">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 p-0">
                <img
                  className="img-fluid w-100 sub-banner-img"
                  src="assest/photos/yellow-action-back.png"
                  alt="G-Rank"
                />
                <div className="sub-banner-div">
                  <h1>0.5</h1>
                  <h2>Years of Association</h2>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* what we offer start */}
        <section className="challenge-sec">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-6">
                <h1 className="social-header">Challenges:</h1>
              </div>
              <div className="col-12 col-lg-6 what-we-offer-div align-self-center case-padding-none">
                <p>
                  Design and develop a high-performance corporate website with
                  multiple pages including Home, About Us, Category, Athletes,
                  and Featured Products for Performax.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* what we offer end */}
        {/* what we offer start */}
        <section className="">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h1 className="social-header">What We Offered:</h1>
              </div>
              <div className="col-12 col-lg-6 what-we-offer-div" id="order2">
                <p>
                  Website Designing, <br />
                  Development
                </p>
              </div>
              <div className="col-12 col-lg-6" id="order1">
                <img
                  className="img-fluid "
                  src="assest/photos/case-studies/what-we-offer-img2.png"
                  alt="G-Rank"
                />
              </div>
            </div>
          </div>
        </section>
        {/* what we offer end */}
        {/* what we offer start */}
        <section className="challenge-sec">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-6">
                <h1 className="social-header">Language Used:</h1>
              </div>
              <div className="col-12 col-lg-6 what-we-offer-div2 align-self-center case-padding-none">
                <p>
                  HTML <br />
                  CSS BOOTSTRAP <br />
                  JQUERY JAVASCRIPT <br />
                  PHP
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* what we offer end */}

        {/* what we offer start */}
        <section className="performax-end-div">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h1 className="social-header">Results:</h1>
              </div>
              <div className="col-12 col-lg-6">
                <h1 className="social-header">Loading Time:</h1>
              </div>
              <div className="col-12 col-lg-6 what-we-offer-div2 align-self-center case-padding-none">
                <p>4 seconds</p>
              </div>
              <div className="col-12 col-lg-6">
                <h1 className="social-header">Performance:</h1>
              </div>
              <div className="col-12 col-lg-6 what-we-offer-div2 align-self-center case-padding-none">
                <p>85%</p>
              </div>
            </div>
          </div>
        </section>
        {/* what we offer end */}
      </section>
    </>
  );
};

export default Performax;
